import { defineComponent as _defineComponent } from 'vue'
import AccountSwitcher from '@/components/views/main/AccountSwitcher.vue';
import MainMenuGroup from '@/components/views/main/MainMenuGroup.vue';
import GMenuItem from '@/components/util/MenuItem.vue';
import i18n, { supportedLanguages } from '@/plugins/i18n';

import { computed, ref } from 'vue';
import {
  MenuItem, reservationMenuItems, settingsMenuItems, reportsMenuItems, newsletterMenuItems,
} from '@/util/menu';

import { performAction } from '@/services/vue-utils';
import GstplnApp from '@/components/apps/app';
import setLanguage from '@/plugins/i18n-locale';
import { tryCloseEditReservation } from '@/services/reservation-edit-utils';
import { useToast, useVuetify } from '@/components/helpers/vue2-helpers';
import store from '@/store/store';
import usePwaInstall from '@/composables/pwa-install';
import useActivityIndicator from '@/composables/activity-indicator';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenu',
  props: {
  miniVariant: { type: Boolean, required: false, default: false },
  collapsable: { type: Boolean, required: false, default: false },
},
  emits: ['menu-collapse', 'menu-expand', 'logout', 'dark-mode'],
  setup(__props, { emit }) {

const props = __props;

const inlineHelpAllowed = process.env.VUE_APP_INLINE_DOCS === 'true';
const pwaDebug = process.env.NODE_ENV !== 'production';

const vuetify = useVuetify();




const { showActivity } = useActivityIndicator();

const mobileVariant = computed(() => vuetify.breakpoint.smAndDown);

const unreadReservationsBadge = computed(() => {
  const unread = store.getters.unreadReservationsCount;
  return unread > 0 ? `${unread}` : null;
});

const settingItems = computed(() => {
  const billingPageAllowed = store.getters.isBillingPageAllowed;
  return settingsMenuItems({ billingPageAllowed });
});

const reportsItems = computed(() => reportsMenuItems());

const appsMenuItems = computed(() => {
  const gstplnApps = store.getters.gstplnApps as GstplnApp[];
  // no apps -> no apps menu
  if (gstplnApps.length === 0) return [];

  const menuApps = gstplnApps.filter((ai) => ai.installed && ai.hasMenuItem);
  const appMenuItems: MenuItem[] = menuApps.map((ai) => {
    const subitems = (ai.routeConfig?.length ?? 0) > 1
      ? ai.routeConfig?.filter((rc) => rc.title !== undefined)
        .map((rc) => ({ text: rc.title, link: `${ai.url}/${rc.route}` } as MenuItem))
      : undefined;
    return {
      text: ai.title(), link: subitems ? undefined : ai.url, icon: ai.icon, subitems,
    };
  });
  return [
    { text: i18n.t('title.manage_apps'), link: '/apps/manage' }, ...appMenuItems,
  ];
});

// Menu Collapse/Decollapse
const settingsGroup = ref(false);
const appsGroup = ref(false);

const collapseMenu = () => {
  appsGroup.value = false;
  settingsGroup.value = false;
  emit('menu-collapse');
};

const settingsClicked = () => { emit('menu-expand'); };
const appsClicked = () => { emit('menu-expand'); };

//

const reload = async () => {
  await performAction(
    null,
    i18n.tc('error.load_data'),
    async () => store.dispatch('update'),
  );
};

const changeLanguage = async (lang: string) => {
  if (!await tryCloseEditReservation()) { return; }

  showActivity(true);
  const cc = store.state.settings.account.countryCode || '';
  setLanguage(lang, cc);
  // eslint-disable-next-line no-restricted-globals
  location.reload();
};

// PWA
const { isInstallable, installPrompt } = usePwaInstall();


return { __sfc: true,inlineHelpAllowed, pwaDebug, vuetify, emit, props, showActivity, mobileVariant, unreadReservationsBadge, settingItems, reportsItems, appsMenuItems, settingsGroup, appsGroup, collapseMenu, settingsClicked, appsClicked, reload, changeLanguage, isInstallable, installPrompt, AccountSwitcher, MainMenuGroup, GMenuItem, supportedLanguages, reservationMenuItems, newsletterMenuItems }
}

})